import { useTranslation } from "react-i18next"

export const GenericErrorBlock = () => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col items-center h-full lg:h-[40%] justify-center text-center">
            <div className="border rounded-[24px] dark:border-darkMode-warning border-opacity-65 p-6 max-w-[600px]">
                <h2 className="text-[20px] font-bold mb-4">{t("genericErrorBlock.title")}</h2>
                <div>
                    <p>{t("genericErrorBlock.desc1")}</p>
                    <p>{t("genericErrorBlock.desc2")}</p>
                </div>
            </div>
        </div>
    )
}
